// Exportacao do resultado de links em massa (CSV e "copiar todos"). Puro.

import { conversionMessage, STATUS_LABELS } from "@/lib/affiliate-ui";
import type { ConversionResult } from "@/lib/hooks/useConvertLink";
import { marketplaceLabel } from "@/lib/marketplace";

const CSV_HEADER = ["status", "loja", "link_original", "link_gerado", "tipo", "titulo", "motivo"] as const;

/** Escapa um campo CSV (RFC 4180) e neutraliza injecao de formula em planilha. */
export function escapeCsvField(value: string): string {
  const guarded = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
  return /[",\n\r]/.test(guarded) ? `"${guarded.replace(/"/g, '""')}"` : guarded;
}

export function toCsv(items: readonly ConversionResult[]): string {
  const rows = items.map((item) => [
    STATUS_LABELS[item.status],
    item.store ? marketplaceLabel(item.store) : "",
    item.inputUrl,
    item.finalUrl ?? "",
    item.linkType === "short" ? "curto" : item.linkType === "direct" ? "direto" : "",
    item.product?.title ?? "",
    item.status === "converted" ? "" : conversionMessage(item.errorCode),
  ]);
  return [CSV_HEADER, ...rows].map((row) => row.map(escapeCsvField).join(",")).join("\r\n");
}

/** Links gerados com sucesso, um por linha, na ordem do lote. */
export function convertedLinks(items: readonly ConversionResult[]): string {
  return items
    .filter((item) => item.status === "converted" && item.finalUrl)
    .map((item) => item.finalUrl as string)
    .join("\n");
}
